import React, {useEffect, useMemo} from 'react';
import {MapContainer, Marker, Polyline, Tooltip, useMap} from 'react-leaflet';
import L, {divIcon} from 'leaflet';
import '../../../../node_modules/leaflet/dist/leaflet.css';
import CustomTileLayer from "../layout/map/CustomTileLayer.js";
import {marqueursEquipe, positionsCadrage, traceEquipe} from "./simulationRules";

// Couleurs d'équipe : tokens existants de DESIGN.md §1 (navy, vert maison, brun, orange, violet) — aucun hex nouveau.
const COULEURS_EQUIPE = ['#213067', '#7bb421', '#B1560F', '#F39A3F', '#9d23d1'];
const couleur = (equipe) => COULEURS_EQUIPE[(equipe - 1) % COULEURS_EQUIPE.length];

function iconNumero(numero, equipe) {
    return divIcon({
        className: 'simulation-marker',
        html: `<span style="display:flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:50%;background:${couleur(equipe)};color:#fff;font-weight:700;font-size:12px;border:2px solid #fff">${numero}</span>`,
        iconSize: [26, 26],
        iconAnchor: [13, 13],
    });
}

function iconPoint(lettre) {
    return divIcon({
        className: 'simulation-marker',
        html: `<span style="display:flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:4px;background:#fff;color:#213067;font-weight:800;font-size:12px;border:2px solid #213067">${lettre}</span>`,
        iconSize: [26, 26],
        iconAnchor: [13, 13],
    });
}

function Ajuste({positions}) {
    const map = useMap();
    useEffect(() => {
        if (positions.length === 1) map.setView(positions[0], 14);
        else if (positions.length > 1) map.fitBounds(L.latLngBounds(positions), {padding: [40, 40]});
    }, [map, positions]);
    return null;
}

/**
 * Carte d'une journée : marqueurs numérotés dans l'ordre de l'API (U-5), polyline base → visites → retour,
 * base (B) et dépôt (D) marqués. `equipes` : numéros d'équipe qui travaillent ce jour-là.
 */
function SimulationJourneeMap({points, equipes, trajets = {}, base, depot}) {
    const couches = useMemo(() => equipes.map((e) => {
        const marqueurs = marqueursEquipe(points, e);
        return {equipe: e, marqueurs, trace: traceEquipe(marqueurs, base, depot, Boolean(trajets[e]))};
    }), [points, equipes, trajets, base, depot]);

    const positions = useMemo(() => positionsCadrage(points, equipes), [points, equipes]);

    return (
        <MapContainer center={[46.6, 2.4]} zoom={6} style={{height: '60vh', width: '100%'}}>
            <CustomTileLayer maxZoom={19}/>
            <Ajuste positions={positions}/>
            {couches.map((c) => (
                <React.Fragment key={c.equipe}>
                    {c.trace.length > 1 && <Polyline positions={c.trace} pathOptions={{color: couleur(c.equipe), weight: 3}}/>}
                    {c.marqueurs.map((m) => (
                        <Marker key={`${c.equipe}-${m.numero}`} position={m.position} icon={iconNumero(m.numero, c.equipe)}>
                            <Tooltip>{m.numero}. {m.nomenclature}</Tooltip>
                        </Marker>
                    ))}
                </React.Fragment>
            ))}
            {Object.values(trajets).some(Boolean) && base?.lat != null && <Marker position={[base.lat, base.lon]} icon={iconPoint('B')}><Tooltip>Base de départ</Tooltip></Marker>}
            {Object.values(trajets).some(Boolean) && depot?.lat != null && <Marker position={[depot.lat, depot.lon]} icon={iconPoint('D')}><Tooltip>Dépôt local</Tooltip></Marker>}
        </MapContainer>
    );
}

export default SimulationJourneeMap;
